import React from 'react'
import { useEffect } from 'react';

const tawkToPropertyId = '60d3a9667f4b000ac0393950'

// Direct Chat Link
// https://tawk.to/chat/tawkToPropertyId/tawkToKey

const tawkToKey = '7c5f1867e9d38af713668dec8094a2eb374b12eb'

export default function Chat() {
    useEffect(() => {
        // Load Tawk.to script dynamically
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://embed.tawk.to/${tawkToPropertyId}/${tawkToKey}`;
        script.charset = 'UTF-8';
        script.setAttribute('crossorigin', '*');
        
        document.head.appendChild(script);
        
        // Cleanup function to remove script when component unmounts
        return () => {
            const existingScript = document.querySelector(`script[src*="${tawkToPropertyId}"]`);
            if (existingScript) {
                document.head.removeChild(existingScript);
            }
        };
    }, [])
    
    return (
        <div>
            
        </div>
    )
}

